var ResponseCode = /*#__PURE__*/ function(ResponseCode) {
    ResponseCode[ResponseCode["Successful"] = 1] = "Successful";
    ResponseCode[ResponseCode["UsernameNotFound"] = 2] = "UsernameNotFound";
    ResponseCode[ResponseCode["InvalidPhoneNumber"] = 3] = "InvalidPhoneNumber";
    ResponseCode[ResponseCode["PasswordIsInCorrect"] = 4] = "PasswordIsInCorrect";
    ResponseCode[ResponseCode["UserLocked"] = 5] = "UserLocked";
    ResponseCode[ResponseCode["NeedCaptcha"] = 7] = "NeedCaptcha";
    ResponseCode[ResponseCode["NeedOtp"] = 8] = "NeedOtp";
    ResponseCode[ResponseCode["CaptchaVerificationFailed"] = 9] = "CaptchaVerificationFailed";
    ResponseCode[ResponseCode["InvalidCredentials"] = 10] = "InvalidCredentials";
    ResponseCode[ResponseCode["OtpVerificationFailed"] = 11] = "OtpVerificationFailed";
    ResponseCode[ResponseCode["UsernameExists"] = 12] = "UsernameExists";
    ResponseCode[ResponseCode["PasswordAlreadyUsed"] = 13] = "PasswordAlreadyUsed";
    ResponseCode[ResponseCode["NeedPhoneAssociation"] = 14] = "NeedPhoneAssociation";
    ResponseCode[ResponseCode["PhoneAssociationFailed"] = 15] = "PhoneAssociationFailed";
    ResponseCode[ResponseCode["DidNotMeetCriteria"] = 16] = "DidNotMeetCriteria";
    ResponseCode[ResponseCode["Unauthenticated"] = 17] = "Unauthenticated";
    ResponseCode[ResponseCode["ErrorOccurred"] = 20] = "ErrorOccurred";
    ResponseCode[ResponseCode["InvalidQueryParameter"] = 21] = "InvalidQueryParameter";
    ResponseCode[ResponseCode["FeatureNotEnabled"] = 22] = "FeatureNotEnabled";
    ResponseCode[ResponseCode["GetPartnerTokenFailed"] = 23] = "GetPartnerTokenFailed";
    ResponseCode[ResponseCode["AllowDeletion"] = 24] = "AllowDeletion";
    ResponseCode[ResponseCode["UpComingBooking"] = 25] = "UpComingBooking";
    ResponseCode[ResponseCode["PastBookingTooRecent"] = 26] = "PastBookingTooRecent";
    ResponseCode[ResponseCode["HasSpecialRole"] = 27] = "HasSpecialRole";
    ResponseCode[ResponseCode["DeletionIncomplete"] = 28] = "DeletionIncomplete";
    ResponseCode[ResponseCode["PartnerClaimTokenNotFound"] = 29] = "PartnerClaimTokenNotFound";
    ResponseCode[ResponseCode["OtpVerificationLimitExceeded"] = 30] = "OtpVerificationLimitExceeded";
    ResponseCode[ResponseCode["OtpNotRequired"] = 36] = "OtpNotRequired";
    ResponseCode[ResponseCode["OtpTypeToBeSelected"] = 42] = "OtpTypeToBeSelected";
    ResponseCode[ResponseCode["CouldNotSendEmail"] = 32] = "CouldNotSendEmail";
    ResponseCode[ResponseCode["CouldNotSendOtp"] = 37] = "CouldNotSendOtp";
    ResponseCode[ResponseCode["PhoneAlreadyVerified"] = 38] = "PhoneAlreadyVerified";
    ResponseCode[ResponseCode["MagicLinkSent"] = 39] = "MagicLinkSent";
    ResponseCode[ResponseCode["RequestBlocked"] = 41] = "RequestBlocked";
    ResponseCode[ResponseCode["NotAValidTransaction"] = 45] = "NotAValidTransaction";
    ResponseCode[ResponseCode["NeedSignupInfo"] = 47] = "NeedSignupInfo";
    ResponseCode[ResponseCode["OtpSendCountExceeded"] = 35] = "OtpSendCountExceeded";
    ResponseCode[ResponseCode["DobRequired"] = 48] = "DobRequired";
    ResponseCode[ResponseCode["NeedPinInput"] = 49] = "NeedPinInput";
    ResponseCode[ResponseCode["NeedPinSetup"] = 50] = "NeedPinSetup";
    ResponseCode[ResponseCode["IncorrectPin"] = 51] = "IncorrectPin";
    ResponseCode[ResponseCode["NeedPinAndOtp"] = 52] = "NeedPinAndOtp";
    ResponseCode[ResponseCode["NeedConsentInfo"] = 53] = "NeedConsentInfo";
    ResponseCode[ResponseCode["NeedPasskeyRegistration"] = 56] = "NeedPasskeyRegistration";
    ResponseCode[ResponseCode["RequestSocialLogin"] = 57] = "RequestSocialLogin";
    ResponseCode[ResponseCode["UserHasPasskey"] = 58] = "UserHasPasskey";
    return ResponseCode;
}({});

var OtpType = /*#__PURE__*/ function(OtpType) {
    OtpType["Phone"] = "phone";
    OtpType["Email"] = "email";
    OtpType["Push"] = "push";
    OtpType["Text"] = "text";
    OtpType["EmailAndPush"] = "email_push";
    OtpType["Whatsapp"] = "whatsapp";
    return OtpType;
}({});

var GdprEraseStatus = /*#__PURE__*/ function(GdprEraseStatus) {
    GdprEraseStatus[GdprEraseStatus["Error"] = -1] = "Error";
    GdprEraseStatus[GdprEraseStatus["AllowDeletion"] = 0] = "AllowDeletion";
    GdprEraseStatus[GdprEraseStatus["UpComingBooking"] = 1] = "UpComingBooking";
    GdprEraseStatus[GdprEraseStatus["PastBookingTooRecent"] = 2] = "PastBookingTooRecent";
    GdprEraseStatus[GdprEraseStatus["HasSpecialRole"] = 3] = "HasSpecialRole";
    GdprEraseStatus[GdprEraseStatus["DeletionIncomplete"] = 4] = "DeletionIncomplete";
    return GdprEraseStatus;
}({});

var OtpChannelStatus = /*#__PURE__*/ function(OtpChannelStatus) {
    OtpChannelStatus["Success"] = "Success";
    OtpChannelStatus["Failure"] = "Failure";
    return OtpChannelStatus;
}({});

var SocialAssociationStatus = /*#__PURE__*/ function(SocialAssociationStatus) {
    SocialAssociationStatus["SUCCESS"] = "success";
    SocialAssociationStatus["ALREADY_LINKED"] = "already_linked";
    SocialAssociationStatus["INVALID_SOCIAL_TYPE"] = "invalid_social_type";
    SocialAssociationStatus["EMAIL_CONSENT_REQUIRED"] = "email_consent_required";
    SocialAssociationStatus["SOCIAL_EMAIL_MISSING"] = "social_email_missing";
    SocialAssociationStatus["AGODA_EMAIL_MISSING"] = "agoda_email_missing";
    SocialAssociationStatus["ALREADY_LINKED_TO_OTHER"] = "already_linked_to_other";
    SocialAssociationStatus["EMAIL_MISMATCH"] = "email_mismatch";
    SocialAssociationStatus["INTERNAL_ERROR"] = "internal_error";
    return SocialAssociationStatus;
}({});
// Status codes from customer-api AssociateSocialStatusCode
var SocialAssociationStatusCode = /*#__PURE__*/ function(SocialAssociationStatusCode) {
    SocialAssociationStatusCode[SocialAssociationStatusCode["SUCCESS"] = 200] = "SUCCESS";
    SocialAssociationStatusCode[SocialAssociationStatusCode["ALREADY_LINKED"] = 201] = "ALREADY_LINKED";
    SocialAssociationStatusCode[SocialAssociationStatusCode["INVALID_SOCIAL_TYPE"] = 210] = "INVALID_SOCIAL_TYPE";
    SocialAssociationStatusCode[SocialAssociationStatusCode["EMAIL_CONSENT_REQUIRED"] = 211] = "EMAIL_CONSENT_REQUIRED";
    SocialAssociationStatusCode[SocialAssociationStatusCode["SOCIAL_EMAIL_MISSING"] = 212] = "SOCIAL_EMAIL_MISSING";
    SocialAssociationStatusCode[SocialAssociationStatusCode["AGODA_EMAIL_MISSING"] = 213] = "AGODA_EMAIL_MISSING";
    SocialAssociationStatusCode[SocialAssociationStatusCode["ALREADY_LINKED_TO_OTHER"] = 214] = "ALREADY_LINKED_TO_OTHER";
    SocialAssociationStatusCode[SocialAssociationStatusCode["EMAIL_MISMATCH"] = 215] = "EMAIL_MISMATCH";
    SocialAssociationStatusCode[SocialAssociationStatusCode["INTERNAL_ERROR"] = 299] = "INTERNAL_ERROR";
    return SocialAssociationStatusCode;
}({});
var mapStatusCodeToStatus = function(statusCode) {
    switch(statusCode){
        case 200:
            return "success";
        case 201:
            return "already_linked";
        case 210:
            return "invalid_social_type";
        case 211:
            return "email_consent_required";
        case 212:
            return "social_email_missing";
        case 213:
            return "agoda_email_missing";
        case 214:
            return "already_linked_to_other";
        case 215:
            return "email_mismatch";
        case 299:
            return "internal_error";
        default:
            return "internal_error";
    }
};
var isSuccessStatusCode = function(statusCode) {
    return statusCode === 200 || statusCode === 201;
};

export { GdprEraseStatus, OtpChannelStatus, OtpType, ResponseCode, SocialAssociationStatus, SocialAssociationStatusCode, isSuccessStatusCode, mapStatusCodeToStatus };
